module.exports = __webpack_public_path__ + "static/media/Portrait-10056.80d8fbcc.jpg";